enum InputType {
	Input = 'input',
	Checkbox = 'checkbox',
	Dropdown = 'dropdown',
	Autocomplete = 'autocomplete',
	Phone = 'phone',
}

export default InputType;
